import BaseModel from './BaseModel';

class ElectricityBillDetails extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id
    this.consumed_electric_units_as_per_system = data.consumed_electric_units_as_per_system.toFixed(2)
    this.consumed_electric_units_as_per_user = data.consumed_electric_units_as_per_user
    this.reimbursement_voucher_number = data.reimbursement_voucher_number
    this.from_and_to_date = `${data.from_date} - ${data.to_date}`
    this.payment_mode = data.payment_mode
    this.bill_amount = data.bill_amount
    this.system_calculated_amount = data.system_calculated_amount.toFixed(2)
    this.approved_amount = data.approved_amount
    this.status = data.status
    this.charging_partner = `${data.charging_partner.nomenclature} | ${data.charging_partner.firm.name}`
    this.charging_zone = `${data.charging_zone.name}`
    this.service_provider = data.service_provider.name
    this.bill_units_readings = `From ${data.smr_from_bill} to ${data.emr_from_bill}`
    this.due_date = data.due_date
    this.transfer_amount = `Wallet ${data.wallet_transfer_amount} Account ${data.account_transfer_amount}`
    this.charging_stations = data.charging_stations.map((cs)=>cs.serial_no)
  }
}

export default ElectricityBillDetails;
